module.exports = __webpack_public_path__ + "img/vesper1.cf7eedad.jpg";